import React from 'react'
import { Button, Descriptions, Divider, Form, Switch, Tag } from 'antd'
import { t } from 'i18next'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'
import OneLineSlot from '../BoxPage/OneLineSlot'
import { useForm } from 'antd/es/form/Form'
import { ReactTrixRTEInput } from 'react-trix-rte'
import DescriptionsItem from 'antd/es/descriptions/Item'
import { displayHierarchy } from '../../Common/Common'
import EventInChargeSelect from './EventInChargeSelect'

export default function EventDescription ({ event, updateEventRequest, updateEvent, onClick, setContent, saveContent, mobile, inCharge }) {
  const [form] = useForm()

  const updateContent = (newContent) => {
    setContent(newContent.target.value)
  }

  const level2 = (event) => {
    if (mobile) {
      return <Descriptions.Item label={t('Admin.EventList.table.notify_level_2')}>Non dispo</Descriptions.Item>
    } else if (event.notify_level_2) {
      return <Descriptions.Item label={t('Admin.EventList.table.notify_level_2')}>{t('Admin.Event.notify_level_2')}</Descriptions.Item>
    } else {
      return <Descriptions.Item><Button type='primary' onClick={onClick}>{t('Admin.EventList.table.createLevel2')}</Button></Descriptions.Item>
    }
  }

  return (
    <>
      <Descriptions column={1}>
        <DescriptionsItem label={t('Admin.EventList.table.tag')}>
          <div style={{ display: 'initial' }}>
            {event?.tags && displayHierarchy(event.tags, true)}
          </div>
        </DescriptionsItem>
        <Descriptions.Item label={t('Admin.EventList.table.resolved')}>
          <Form form={form}>
            <Form.Item style={{ marginBottom: '0px' }} name="resolved">
              <Switch onChange={(value) => updateEventRequest({ ...event, resolved: value })} checked={event.resolved} />
            </Form.Item>
          </Form>
        </Descriptions.Item>
        <Descriptions.Item label={t('Admin.EventList.table.number')}>{event.number}</Descriptions.Item>
        <Descriptions.Item label={t('Admin.EventList.table.created_by')}>{event.created_by?.name}</Descriptions.Item>
        <Descriptions.Item label={t('Admin.EventList.table.inCharge')}>
          <EventInChargeSelect event={event} updateEventData={updateEvent} inCharge={inCharge} style={{ minWidth: '15em' }} />
          </Descriptions.Item>
        <Descriptions.Item label={t('Admin.EventList.table.created_at')}>{dayjs(event.created_at).format('DD/MM/YY HH[h]mm[m]ss[s]')}</Descriptions.Item>
        {event.resolved && event.resolved_at &&
          <Descriptions.Item label={t('Admin.EventList.table.resolved_at')}>{dayjs(event.resolved_at).format('DD/MM/YY HH[h]mm')}</Descriptions.Item>
        }
        {!event.resolved &&
          <Descriptions.Item label={t('Admin.EventList.table.resolved_at')}><Tag color="error" variant='solid'>{t('Admin.Event.unresolved')}</Tag></Descriptions.Item>
        }
        {level2(event)}
        {event.box_id && event.box &&
          <>
            <Descriptions.Item label={t('Admin.EventList.table.box')}><Link to={`/admin/boxes/${event.box.id}/calendar`}>{event.box.name}</Link></Descriptions.Item>
            <Descriptions.Item label={t('Admin.EventList.table.teleconsulting_company')}>{event.box.teleconsulting_company_name}</Descriptions.Item>
          </>
        }
        {event.slot_id && event.slot &&
          <Descriptions.Item label={t('Admin.EventList.table.slot')}>
            <OneLineSlot slot={event.slot} onCalendar={false} />
          </Descriptions.Item>
        }
        {event.alert_id && event.alert &&
          <Descriptions.Item label={t('Admin.EventList.table.alert')}>{event.alert.message} <br /> {event.alert.level} </Descriptions.Item>
        }
      </Descriptions>
      <Divider />
      {!!event.id &&
        <Descriptions layout="vertical">
          <Descriptions.Item label={t('Admin.EventList.table.content')}>
            {!mobile &&
              <Form form={form} style={{ width: '100%' }}>
                <Form.Item name="content" style={{ width: '100%' }}>
                  <ReactTrixRTEInput isRailsDirectUpload={true} onChange={updateContent} defaultValue={event.content}
                    onBlur={saveContent}
                    data-direct-upload-url="/rails/active_storage/direct_uploads"
                    data-blob-url-template="/rails/active_storage/blobs/:signed_id/*filename"
                  />
                </Form.Item>
              </Form>}
            {mobile && <p dangerouslySetInnerHTML={{ __html: event.content_string }} />}
          </Descriptions.Item>
        </Descriptions >
      }
    </>
  )
}
